import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProjectDetails from './Project/ProjectDetails';
import ProjectNew from './ProjectNew';
import Home from "./Home";
import Protector from "../../../router/Protector/Protector";
import NavigateToDefault from "../../../router/NavigateToDefault";

class ProjectsRouter extends React.Component {
    render() {
        return (
            <Routes caseSensitive>
                <Route path="/" exact element={<Protector><Home /></Protector>} sensitive />
                <Route path="/new-project" exact element={<Protector><ProjectNew /></Protector>} sensitive />
                <Route path="/:projectid/*" element={<Protector><ProjectDetails /></Protector>} sensitive />
                <Route path="*" element={<NavigateToDefault/>} />
            </Routes>
        );
    }

}


export default ProjectsRouter;